import React, { Component } from 'react';
import { connect } from 'react-redux';
import MyPrivilegesDetailsView from '../../../../modules/myPrivileges/components/MyPrivilegesDetailsView';
import './styles.scss';
import {
  getMyPrivilegesConfig,
  getMyPrivilegeOfferSections,
} from '../../../../modules/myPrivileges/selectors/myPrivilegesSelector';
import { resolveLocalizedText } from '../../../../utils';
import {
  isCWP,
  getMyPrivilegesFeatures,
} from '../../../../modules/home/selectors/serviceSelectors';

import EmmaModalView from '../../../../components/EmmaModalView';
import HealthKeeperModalView from '../../../../components/EmmaModalView/HealthKeeperModal/HealthKeeperModalView';
import VhisModalView from '../../../axagoal/components/VhisModalView';
import EmmaTncStyleModel from '../../../../components/EmmaModalView/TncStyleModel';
import EMMAContactCallModel from '../../../../components/EmmaModalView/ContactCallModel';
import AktivoModalView from '../../../aktivo-onboarding/components/AktivoModalView';
import { getCustomerFeatures } from '../../../../selectors/userSelectors';

export interface MyPrivilegesDetailsContainerProps {
  match: {
    params: {
      myPrivilegesId: string;
      cardViewId: string;
    };
  };
  title: string;
  profileFeatures: string[];
  isCWP: boolean;
}

export interface MyPrivilegesConfigProps {
  title?: string;
  banner: {
    largeViewPointImage?: string;
    smallViewPointImage?: string;
    title?: string;
    desc?: string;
  };
}

export interface MyPrivilegesDetailsContainerState {}

export class MyPrivilegesDetailsContainer extends Component<
  MyPrivilegesDetailsContainerProps,
  MyPrivilegesDetailsContainerState
> {
  constructor(props: any = {}) {
    super(props);
  }

  componentDidMount() {}

  render() {
    const { myPrivilegesId, cardViewId } = this.props.match.params;
    const { isCWP, title, profileFeatures } = this.props;
    if (!profileFeatures) {
      return null;
    }

    let filteredCardViewId = '';
    if (profileFeatures) {
      filteredCardViewId = profileFeatures.includes(cardViewId)
        ? cardViewId
        : '';
      if (!filteredCardViewId) {
        return null;
      }
    } else {
      return null;
    }

    return (
      <div className="myprivileges-details-view-container">
        <EmmaModalView />
        <HealthKeeperModalView />
        <VhisModalView />
        <EmmaTncStyleModel />
        <EMMAContactCallModel />
        <AktivoModalView />
        {title && (
          <div className="myprivileges-details-view-container__title">
            {title}
          </div>
        )}
        <MyPrivilegesDetailsView
          myPrivilegesId={myPrivilegesId}
          cardViewId={filteredCardViewId}
        />
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const myPrivilegesConfig = getMyPrivilegesConfig(state);
    const privilegesFeaturesConfig = getMyPrivilegesFeatures(state);
    const privilegeOfferSections = getMyPrivilegeOfferSections(state);
    const consumerFeatures = getCustomerFeatures(state);
    let features: any = [].concat(consumerFeatures);
    if (privilegesFeaturesConfig && privilegesFeaturesConfig.features) {
      privilegesFeaturesConfig.features.forEach((item: any) => {
        features = features.concat(item.subFeatures);
      });
    }

    // Fix - Without 'features.length > 0', this container will render before API finish
    if (features.length > 0 && privilegeOfferSections) {
      privilegeOfferSections.forEach((item: any) => {
        features = features.concat(item.featureId);
      });
    }
    const profileFeatures = (features || []).slice();

    return {
      title: myPrivilegesConfig.title
        ? resolveLocalizedText(myPrivilegesConfig.title)
        : '',
      profileFeatures: profileFeatures,
      isCWP: isCWP(state),
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  MyPrivilegesDetailsContainer.mapStateToProps,
  MyPrivilegesDetailsContainer.mapDispatchToProps,
)(MyPrivilegesDetailsContainer);
